export default __webpack_public_path__ + "static/media/catalogo.052f2ff2.png";